import React from 'react';
import Login from 'src/ui/features/Login/presentational/LoginPres';
import LoginSso from 'src/ui/features/Login/presentational/LoginSsoPres';
import { LOGINPAGE, LOGINSSOPAGE } from '../state/constants';

const getComponent = loginPage => {
  switch (loginPage) {
    case LOGINPAGE:
      return Login;
    case LOGINSSOPAGE:
      return LoginSso;
    default:
      return LoginSso;
  }
};

export default props => {
  const { loginPage, ...otherProps } = props;
  const Component = getComponent(loginPage);
  return <Component key={loginPage} {...otherProps} />;
};
